import React from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';

// 내부 컴포넌트: 헤더 스타일 (높이 축소 및 폰트 강조)
const HeaderItem = ({ xs, label }) => (
  <Grid item xs={xs} align="center">
    <Typography sx={{ fontWeight: 'bold', color: '#333', fontSize: '0.9rem', lineHeight: '32px' }}>
      {label}
    </Typography>
  </Grid>
);

// 내부 컴포넌트: 데이터 스타일 (높이 축소 및 폰트 크기 유지)
const DataItem = ({ xs, value, color = 'text.primary' }) => (
  <Grid item xs={xs} align="center">
    <Typography sx={{ fontSize: '0.95rem', color: color, lineHeight: '32px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {value || '-'}
    </Typography>
  </Grid>
);

const ApprovalSummary = ({ info }) => {
  const getStatus = (yn) => {
    if (yn === 'S') return { text: '진행중', color: '#1976d2' };
    if (yn === 'Y') return { text: '완료', color: '#2e7d32' };
    if (yn === 'N') return { text: '거부', color: '#d32f2f' };
    return { text: '-', color: 'text.secondary' };
  };

  const status = getStatus(info?.docuYn);

  return (
    <Box sx={{ width: '100%' }}>
      {/* 헤더 영역: 높이 고정 및 패딩 제거 */}
      <Grid 
        container 
        sx={{ 
          height: '32px', 
          bgcolor: '#f1f3f5', 
          alignItems: 'center'
        }}
      >
        <HeaderItem xs={2} label="결재 문서번호" />
        <HeaderItem xs={2} label="작성일자" />
        <HeaderItem xs={1.5} label="매출 예상일" />
        <HeaderItem xs={1} label="결재타입" />
        <HeaderItem xs={1} label="영업담당" />
        <HeaderItem xs={1} label="기안자" />
        <HeaderItem xs={1.5} label="결재상태" />
        <HeaderItem xs={2} label="최종승인일자" />
      </Grid>

      {/* 데이터 영역: 높이 고정 및 패딩 제거 */}
      <Grid 
        container 
        sx={{ 
          height: '32px', 
          alignItems: 'center', 
          bgcolor: '#fff' 
        }}
      >
        <DataItem xs={2} value={info?.docuNo} />
        <DataItem xs={2} value={info?.crtDt} />
        <DataItem xs={1.5} value={info?.expDay} />
        <DataItem xs={1} value={info?.docyTyp} />
        <DataItem xs={1} value={info?.salesNm} />
        <DataItem xs={1} value={info?.crtNm} />
        <DataItem xs={1.5} value={status.text} color={status.color} />
        <DataItem xs={2} value={info?.docuDt} />
      </Grid>
      <Divider />
    </Box>
  );
};

export default ApprovalSummary;
